import { connect } from "react-redux";
import React, { useEffect, useMemo, useState } from "react";
import { Row, Col } from "react-bootstrap";

import ReactApexChart from "react-apexcharts";
import Topbar from "../../shared/components/topbar/Topbar";
import { storeActions, systemActions } from "../../redux/actions";
import {
  getTimeFrame,
  parseToNumber,
  parseToThousandSeperatorDecimalNumber,
} from "../../shared/utility";
import DashboardDatePicker from "../../shared/components/datetimePickerDropdown/DashboardDatePicker";
import Billing from "../Billing/Billing";
import SimpleNumberField from "../../shared/components/inputNumberField/SimpleNumberField";
import {
  CloseIcon,
  PercentageIcon,
  TickIconLong,
} from "../../assets/icons/iconsProvider";
import {
  PRODUCT_CONDITIONS_ENUMS,
  SET_BY_MARGIN_ENUMS,
  STORE_CARD_PAYMENT_TYPE_ENUMS,
} from "../../system/globalEnums";
import { Button } from "../../shared/components";
import CustomTaxRulesModal from "./CustomTaxRulesModal";
import AddCustomSalesTaxRule from "./AddCustomSalesTaxRule";
import { EMPTY_STRING, inventoryConstants } from "../../constants";
const Payouts = (props) => {
  const {
    currentStore,
    payouts,
    inventory,
    getPayoutsInformation,
    editSaleTax,
    addSaleTax,
  } = props;
  const [showCustomTaxRulesModal, setShowCustomTaxRulesModal] = useState(false);
  const [showAddCustomSalesTaxRuleModal, setShowAddCustomSalesTaxRuleModal] =
    useState(false);
  const [isEditingSaleTax, setIsEditingSaleTax] = useState(false);
  const [currentEditingSaleTax, setCurrentEditingSaleTax] = useState({});
  const [timeframe, setTimeFrame] = useState({
    start: "",
    end: "",
    duration: "daily",
  });
  const [selectedCondition, setSelectedCondition] = useState(
    inventoryConstants.VIDEO_GAME_CONDITION[0]
  );
  const [selectedTags, setSelectedTags] = useState([]);

  const productConditionList = [
    ...inventoryConstants.VIDEO_GAME_CONDITION,
    {
      value: PRODUCT_CONDITIONS_ENUMS.USED,
      label: PRODUCT_CONDITIONS_ENUMS.USED,
    },
  ];

  const series = [
    parseToNumber(payouts?.netCashSale),
    parseToNumber(payouts?.netCreditCardSale),
  ];

  const totalEarnings = useMemo(() => {
    return (payouts?.netCashSale ?? 0) + (payouts?.netCreditCardSale ?? 0);
  }, [payouts]);

  const options = useMemo(
    () => ({
      chart: {
        id: `basic-bar${Math.random()}`,
        type: "donut",
      },
      labels: ["Cash Sales", "Credit Card Sales"],
      colors: ["#6A18ED", "rgba(217, 215, 219, 1)"],
      dataLabels: {
        enabled: false,
      },
      plotOptions: {
        pie: {
          expandOnClick: false,
          donut: {
            size: "80%",
            labels: {
              show: true,
              total: {
                show: true,
                showAlways: true,
                label: "Earnings",
                color: "#6A18ED",
                formatter: function (w) {
                  return `$${parseToThousandSeperatorDecimalNumber(
                    totalEarnings
                  )}`;
                },
              },
            },
          },
        },
      },
      legend: {
        show: false,
      },
    }),
    // eslint-disable-next-line
    [payouts]
  );

  const handleGetTimeFrame = (value) => {
    getTimeFrame(value, timeframe, setTimeFrame);
  };

  useEffect(() => {
    if (currentStore && timeframe.start && timeframe.end) {
      getPayoutsInformation(currentStore?.id, timeframe.start, timeframe.end);
    } // eslint-disable-next-line
  }, [currentStore, timeframe]);
  useEffect(() => {
    setUpdateTax(payouts?.defaultTax); // eslint-disable-next-line
  }, [payouts]);

  const [isEditSaleTax, setIsEditSaleTax] = useState(false);
  const [updateTax, setUpdateTax] = useState("");
  const toggleEditSaleTax = () => {
    setIsEditSaleTax((prevValue) => !prevValue);
  };
  const hanldeEditSaleTaxCancel = () => {
    toggleEditSaleTax();
    setUpdateTax(payouts?.defaultTax);
  };
  const onChangeTaxValue = (inputValue) => {
    setUpdateTax(inputValue);
  };
  const handleEditedSaleTax = (values) => {
    toggleEditSaleTax();
    editSaleTax(
      {
        storeId: currentStore?.id,
        startDate: timeframe.start,
        endDate: timeframe.end,
      },
      {
        defaultTax: updateTax,
      }
    );
  };
  const handleAddCustomSalesTaxRule = (data) => {
    const { selectedCategories } = data;
    let categoriesToSend = [];
    if (data.setBy === SET_BY_MARGIN_ENUMS.SUBCATEGORY.value) {
      categoriesToSend = selectedCategories.map((option) => {
        return {
          categoryId: option.id,
          categoryName: option.name,
          parentCategoryId: option.parentCategoryId,
          parentCategoryName: option.parentCategoryName,
        };
      });
    } else if (data.setBy === SET_BY_MARGIN_ENUMS.CATEGORY.value) {
      categoriesToSend = selectedCategories.map((option) => {
        return {
          categoryId: option.id,
          categoryName: option.name,
        };
      });
    } else if (data.setBy === SET_BY_MARGIN_ENUMS.TYPE.value) {
      categoriesToSend = selectedCategories.map((option) => {
        return {
          productType: option.name,
        };
      });
    } else if (data.setBy === SET_BY_MARGIN_ENUMS.PRODUCT.value) {
      categoriesToSend = selectedCategories.map((option) => {
        return {
          product_id: option.product_id,
          product_name: option.product_name,
          productType: option.productType,
          category_name: option.category_name,
          cardRarity: option.cardRarity,
          subcategory: option.subcategory,
        };
      });
    }
    const dataToSend = {
      store: {
        name: currentStore.storeName,
        id: currentStore.id,
      },
      saleTaxRate: data.saleTaxRate,
      taxType: data.setBy,
      taxGroup: categoriesToSend,
      ...(data.setBy === SET_BY_MARGIN_ENUMS.PRODUCT.value && {
        tags: selectedTags,
        productCondition: selectedCondition?.value,
      }),
      ...(isEditingSaleTax && { id: currentEditingSaleTax.id }),
    };
    if (isEditingSaleTax) {
      editSaleTax(
        {
          storeId: currentStore?.id,
          startDate: timeframe.start,
          endDate: timeframe.end,
        },
        dataToSend,
        `isDefaultTax=false&taxRateType=${data.setBy}&&isCustomTaxRate=true`
      );
    } else {
      addSaleTax(
        currentStore?.id,
        dataToSend,
        `isDefaultTax=false&taxRateType=${data.setBy}&&isCustomTaxRate=true`
      );
    }
  };

  const handleOpenAddCustomSalesTaxRuleModal = (currentTaxRule = null) => {
    if (currentTaxRule) {
      setCurrentEditingSaleTax(currentTaxRule);
      setIsEditingSaleTax(true);
      setSelectedTags(currentTaxRule?.tags || []);
      setSelectedCondition(
        productConditionList.find(
          (condition) => condition.value === currentTaxRule?.productCondition
        ) || inventoryConstants.VIDEO_GAME_CONDITION[0]
      );
    } else {
      setCurrentEditingSaleTax({});
      setIsEditingSaleTax(false);
      setSelectedTags([]);
      setSelectedCondition(inventoryConstants.VIDEO_GAME_CONDITION[0]);
    }
    setShowAddCustomSalesTaxRuleModal(true);
  };

  const handleCloseAddCustomSalesTaxRuleModal = () => {
    setShowAddCustomSalesTaxRuleModal(false);
    setIsEditingSaleTax(false);
    setCurrentEditingSaleTax({});
    setSelectedTags([]);
    setSelectedCondition(inventoryConstants.VIDEO_GAME_CONDITION[0]);
  };

  const handleSelectedTagsChange = (selectedTagsList = []) => {
    const selectedTagsValues = selectedTagsList.map((tag) => tag.label);
    setSelectedTags(selectedTagsValues);
  };

  return (
    <>
      <div className="user-info-wrapper container-scrollbar">
        <Row className="m-0 d-flex justify-content-center w-100 ">
          <Col md={11}>
            <Topbar title="Earnings/Payouts"></Topbar>
            <Row className="m-0 d-flex justify-content-center align-items-center">
              <Col
                md={12}
                className="d-flex justify-content-start align-items-center"
              >
                <DashboardDatePicker getTimeFrame={handleGetTimeFrame} />
              </Col>
              <Col md={12} className="d-flex mt-4">
                <div className="w-50 ">
                  <ReactApexChart
                    options={options}
                    series={series}
                    type="donut"
                    height={300}
                  />
                </div>
                <div className="w-50 d-flex flex-column p-3">
                  <div className="w-100 p-2 d-flex justify-content-between align-items-center py-3 border-bottom">
                    <div className="d-flex align-items-center">
                      <span className="point-indicator"></span>Total Sales
                    </div>
                    <span className="payout-price">
                      $
                      {parseToThousandSeperatorDecimalNumber(
                        payouts?.totalSale || 0
                      )}
                    </span>
                  </div>
                  <div className="w-100 p-2 d-flex justify-content-between align-items-center py-3 border-bottom">
                    <div className="d-flex align-items-center">
                      <span className="point-indicator"></span>Net Sales
                    </div>
                    <span className="payout-price">
                      $
                      {parseToThousandSeperatorDecimalNumber(
                        payouts?.netSales || 0
                      )}
                    </span>
                  </div>
                  <div className="w-100 p-2 d-flex justify-content-between align-items-center py-3 border-bottom">
                    <div className="d-flex align-items-center">
                      <span className="point-indicator grey-color-indicator"></span>
                      Total Credit/Debit Sales
                    </div>
                    <span className="payout-price">
                      $
                      {parseToThousandSeperatorDecimalNumber(
                        payouts?.netCreditCardSale || 0
                      )}
                    </span>
                  </div>
                  <div className="w-100 p-2 d-flex justify-content-between align-items-center py-3 border-bottom">
                    <div className="d-flex align-items-center">
                      <span className="point-indicator"></span>Total Cash Sales
                    </div>
                    <span className="payout-price">
                      $
                      {parseToThousandSeperatorDecimalNumber(
                        payouts?.netCashSale || 0
                      )}
                    </span>
                  </div>
                  <div className="w-100 p-2 d-flex justify-content-between align-items-center py-3 border-bottom">
                    <div className="d-flex align-items-center">
                      <span className="point-indicator"></span>Total Returns
                    </div>
                    <span className="payout-price">
                      $
                      {parseToThousandSeperatorDecimalNumber(
                        payouts?.totalReturns || 0
                      )}
                    </span>
                  </div>
                  <div className="w-100 p-2 d-flex justify-content-between align-items-center py-3 border-bottom">
                    <div className="d-flex align-items-center">
                      <span className="point-indicator"></span>Gross Profit
                    </div>
                    <span className="payout-price">
                      $
                      {parseToThousandSeperatorDecimalNumber(
                        payouts?.grossProfit || 0
                      )}
                    </span>
                  </div>
                </div>
              </Col>
            </Row>
            <Row className="m-0 mt-3">
              <Col
                md={
                  currentStore?.activeCardPaymentType ===
                  STORE_CARD_PAYMENT_TYPE_ENUMS.THIRD_PARTY
                    ? 6
                    : 4
                }
              >
                <div className="payout-card">
                  <span>Collected Tax</span>
                  <span>
                    $
                    {parseToThousandSeperatorDecimalNumber(
                      payouts?.totalCollectedTax || 0
                    )}
                  </span>
                  {/* <span>
                  Collecting tax in <a href="#">United States</a>
                </span> */}
                  <div className="d-flex align-items-center justify-content-between">
                    {!isEditSaleTax ? (
                      <div className="d-flex gap-3">
                        <span>
                          {/* Collecting tax in <a href="#">United States</a> */}
                          Global Sales Tax Rate: {payouts.defaultTax}%
                        </span>
                        {!isEditSaleTax ? (
                          <button
                            type="button"
                            className="edit-budget-button p-0"
                            onClick={() => toggleEditSaleTax()}
                          >
                            Edit
                          </button>
                        ) : (
                          ""
                        )}
                      </div>
                    ) : (
                      <div className="d-flex gap-1  p-1 pe-0">
                        <SimpleNumberField
                          // disabled={true}
                          name="tradeOffer"
                          placeHolder="0"
                          className="add-inventory-price-field input-background"
                          IconImage={PercentageIcon}
                          value={updateTax}
                          onChange={onChangeTaxValue}
                          maxValue={100}
                          minimumValue={0}
                        />
                        <div className="w-100 d-flex  align-content-center ">
                          <button
                            type="button"
                            className="edit-buttons  pe-0"
                            onClick={() => hanldeEditSaleTaxCancel()}
                          >
                            <CloseIcon className="close-button-purchasing-power" />
                          </button>
                          <button
                            onClick={() => handleEditedSaleTax()}
                            type="button"
                            className="edit-buttons pe-0"
                          >
                            <TickIconLong className="close-button-purchasing-power" />
                          </button>
                        </div>
                      </div>
                    )}
                    <Button
                      handleClick={() => {
                        setShowCustomTaxRulesModal(true);
                      }}
                      label="Custom Tax Rules"
                    />
                  </div>
                </div>
              </Col>

              <Col
                md={
                  currentStore?.activeCardPaymentType ===
                  STORE_CARD_PAYMENT_TYPE_ENUMS.THIRD_PARTY
                    ? 6
                    : 4
                }
              >
                <div className="payout-card">
                  <span>Total Purchases</span>
                  <span>
                    $
                    {parseToThousandSeperatorDecimalNumber(
                      payouts?.totalPurchases || 0
                    )}
                  </span>
                  <div className="d-flex justify-content-between align-items-center">
                    <span>
                      (Total Cash/Store Credit Spent to Acquire Products)
                    </span>
                  </div>
                </div>
              </Col>
              {currentStore?.activeCardPaymentType ===
              STORE_CARD_PAYMENT_TYPE_ENUMS.THIRD_PARTY ? (
                ""
              ) : (
                <Col md={4}>
                  <div className="payout-card">
                    <span>Next Payout (Card Sales)</span>
                    <span>$50.00</span>
                    <div className="d-flex justify-content-between align-items-center">
                      <span>Expected Payout Date: 04/10/2024</span>
                    </div>
                  </div>
                </Col>
              )}
            </Row>
          </Col>
        </Row>
        <Row className="m-0 d-flex justify-content-center w-100 ">
          {/* <Col md={8}> */}
          <Billing />
          {/* </Col> */}
        </Row>
      </div>
      <CustomTaxRulesModal
        show={showCustomTaxRulesModal}
        onHide={() => {
          setShowCustomTaxRulesModal(false);
        }}
        showAddCustomSalesTaxRuleModal={showAddCustomSalesTaxRuleModal}
        setShowAddCustomSalesTaxRuleModal={setShowAddCustomSalesTaxRuleModal}
        isEditingSaleTax={isEditingSaleTax}
        setIsEditingSaleTax={setIsEditingSaleTax}
        currentEditingSaleTax={currentEditingSaleTax}
        setCurrentEditingSaleTax={setCurrentEditingSaleTax}
        currentStore={currentStore}
        onAddRuleClick={handleOpenAddCustomSalesTaxRuleModal}
      />
      <AddCustomSalesTaxRule
        show={showAddCustomSalesTaxRuleModal}
        onHide={handleCloseAddCustomSalesTaxRuleModal}
        onSubmit={handleAddCustomSalesTaxRule}
        isEditingSaleTax={isEditingSaleTax}
        setIsEditingSaleTax={setIsEditingSaleTax}
        currentEditingSaleTax={currentEditingSaleTax}
        setCurrentEditingSaleTax={setCurrentEditingSaleTax}
        currentStore={currentStore}
        selectedCondition={selectedCondition}
        setSelectedCondition={setSelectedCondition}
        productTags={inventory?.productTags || []}
        selectedTags={selectedTags}
        setSelectedTags={setSelectedTags}
        handleSelectedTagsChange={handleSelectedTagsChange}
        productConditionList={productConditionList}
      />
    </>
  );
};

//-------Mapping the component's props to the reducer's state
const mapStateToProps = (state) => ({
  currentStore: state.store.currentStore,
  payouts: state.store.payouts,
  inventory: state.inventory,
});

//-------Mapping the component's props to the related actions
const mapDispatchToProps = (dispatch) => ({
  getPayoutsInformation: (storeId, startDate, endDate) =>
    dispatch(storeActions.getPayoutsInformation(storeId, startDate, endDate)),
  activateSpinner: (data) => dispatch(systemActions.activateSpinner(data)),
  deactivateSpinner: (data) => dispatch(systemActions.deactivateSpinner(data)),
  editSaleTax: (ObjectDetail, data, queryParams = EMPTY_STRING) =>
    dispatch(storeActions.editSaleTax(ObjectDetail, data, queryParams)),
  addSaleTax: (storeId, data, queryParams = EMPTY_STRING) =>
    dispatch(storeActions.addSaleTax(storeId, data, queryParams)),
});

//-------Export AddNewUser Component
export default connect(mapStateToProps, mapDispatchToProps)(Payouts);
